import { Button as KvnButton } from "@kirvanobr/button";
import { ButtonProps } from "./Button.types";

export default function Button({ icon, children, disabled, isDisabled, ...props }: ButtonProps) {
  return (
    <KvnButton startContent={icon} isDisabled={disabled || isDisabled} {...props}>
      {children}
    </KvnButton>
  );
}
